import React, { useState, useEffect } from "react";
import ReusableForm from "../../../ExtraComponents/ReusableForm1";
import { Link, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { getAllClient, getClientDetails } from "../../../Service/ThardPartyApi/ThardPartyAPI";
import { createQuote, getQuoteData, getQuoteInfo } from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { createContract, getContractData, getContractInfo } from "../../../ReduxStore/Slice/Contract/contractSlice";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { EMPTY_CLIENT_NAME_ERROR, EMPTY_SECONDARY_QUOTE_TYPE_ERROR, EMPTY_BUSINESS_TYPE_ERROR, EMPTY_CONTRACT_OWNER_ERROR, EMPTY_ENQUIRY_TYPE_ERROR, EMPTY_CHANNEL_ERROR, EMPTY_QUOTE_TYPE_ERROR, EMPTY_CONTRACT_DEFINITION_ERROR, ALERT_MSG_ADHOC_RECCURING_SERVICES } from "../../../Utils/Common_Error";
import { cleanHtmlEntities } from '../../../Utils/CommonFun';


const StepOne = ({ formData, handleChange, nextStep, prevStep, currentStep }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  let QuoteId = sessionStorage.getItem("contract_id");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const company_id = JSON.parse(localStorage.getItem("company_id"));
  const [allClientData, setAllClientData] = useState({});
  const [clientDetails, setClientDetails] = useState({});
  const ContractOwner = JSON.parse(localStorage.getItem("details"));
  const [checkClientType, setCheckClientType] = useState(false);
  const [checkBusinessType, setCheckBusinessType] = useState(false);
  const [checkChannel, setCheckChannel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clientsingledetailsError, setClientsingledetailsError] = useState(false);

  // if (location.state != undefined && location.state != null) {
  //   sessionStorage.setItem("contract_id", location.state.row.id);
  //   QuoteId = location.state.row.id;
  // }

  if (location.state != undefined && location.state != null && location.state.record_id == undefined) {
    if (sessionStorage.getItem("contract_id") != null) {
      sessionStorage.setItem("contract_id", QuoteId);
      QuoteId = QuoteId;
    } else {
      sessionStorage.setItem("contract_id", location.state.row.id);
      QuoteId = location.state.row.id;
    }
  }


  const [quoteDataAllInfo, setQuoteDataAllInfo] = useState({
    quote_type: [],
    business_type: [],
    enquiry_type: [],
    channel: [],
    quote_secondary_type: []
  });

  useEffect(() => {
    getQuote();
  }, [allClientData]);

  useEffect(() => {
    getQuoteInfoFun();
    allClient();
  }, []);

  const getQuoteInfoFun = async () => {
    let req = { agent_id: agent_id };

    await dispatch(getContractInfo(req)).unwrap()
      .then((res) => {
        if (res.status) {

          // console.log("res", res.data);
          setQuoteDataAllInfo({
            business_type: res.data.business_type,
            enquiry_type: res.data.enquiry_type,
            channel: res.data.channel
          });

          formik.setFieldValue("Channel", res?.data?.channel[0]?.id);
          formik.setFieldValue("BusinessType", res?.data?.business_type[0]?.id);
          formik.setFieldValue("EnquiryType", res?.data?.enquiry_type[0]?.id);

        } else {
          setQuoteDataAllInfo({

            business_type: [],
            enquiry_type: [],
            channel: []
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }


  const getQuote = async () => {
    setIsLoading(true)
    if (QuoteId == null || QuoteId == 0){
        setIsLoading(false)
       return;
    } 
    const req = { id: Number(QuoteId), agent_id: agent_id };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          // console.log("res", res);
          formik.setFieldValue("Client", res.contract.record_id);
          formik.setFieldValue("BusinessType", res.contract.business_type);
          formik.setFieldValue("ContractOwner", ContractOwner?.user_fname + " " + ContractOwner?.user_lname);
          formik.setFieldValue("EnquiryType", res.contract.enquiry_type);
          formik.setFieldValue("AdhocServices", res.contract.one_off == "1" ? true : false);
          formik.setFieldValue("Channel", res.contract.channel);
          formik.setFieldValue("ReccuringServices", res.contract.recurring == "1" ? true : false);
          formik.setFieldValue("module_type", res.contract.Client.module_type);
          formik.setFieldValue("contract_definition", res.contract.contract_definition || "");

          const agent_db = localStorage.getItem('agent_db');
          const req = {
            agent_db: agent_db,
            company_id: company_id,
            pricing_tool_pratice_id: agent_id,
            module: res.contract.Client.module_type,
            record_id: res.contract.record_id || 0,
          };
          const token_crm = localStorage.getItem('authClientToken');
          const agent_url = localStorage.getItem('agent_url');
          await getClientDetails(req, agent_url, token_crm).then(async (res) => {
            if (res.IsSuccess) {
              setIsLoading(false)
              setClientDetails(res.result);
            }else{
              setIsLoading(false)
            }

          }).catch((err) => {
            setIsLoading(false)
            console.log("err", err);
          });
        }else{
          setIsLoading(false)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.log("err", err);
      });
  };

  const formik = useFormik({
    initialValues: {
      Client: "",
      BusinessType: "",
      ContractOwner: "",
      EnquiryType: "",
      AdhocServices: false,
      Channel: "",
      ReccuringServices: false,
      module_type: "Leads",
      contract_definition: "",
    },
    validate: (values) => {
      let errors = {};

      if (!values.Client) {
        errors.Client = EMPTY_CLIENT_NAME_ERROR;
      }
      if (!values.BusinessType) {
        errors.BusinessType = EMPTY_BUSINESS_TYPE_ERROR;
      }
      if (!values.ContractOwner) {
        errors.ContractOwner = EMPTY_CONTRACT_OWNER_ERROR;
      }
      if (!values.EnquiryType) {
        errors.EnquiryType = EMPTY_ENQUIRY_TYPE_ERROR;
      }
      if (!values.Channel) {
        errors.Channel = EMPTY_CHANNEL_ERROR;
      }
      if (!values.contract_definition) {
        errors.contract_definition = EMPTY_CONTRACT_DEFINITION_ERROR;
      }
      return errors;
    },
    onSubmit: async (values) => {

      const req = {
        id: QuoteId || "",
        Client: values.Client,
        BusinessType: values.BusinessType,
        ContractOwner: ContractOwner.id,
        EnquiryType: values.EnquiryType,
        AdhocServices: values.AdhocServices == true ? "1" : "0",
        Channel: values.Channel,
        ReccuringServices: values.ReccuringServices == true ? "1" : "0",
        module_type: values.module_type,
        contract_definition: values.contract_definition,
        step: 1,
        ClientDetails: clientDetails,
        agent_id: agent_id,
        contract_random_id: "CID" + Math.floor(1000 + Math.random() * 9000),
      };

      if (clientsingledetailsError == true) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Client details not found. Please select a valid client.",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }


      await dispatch(createContract(req)).unwrap()
        .then((res) => {
          if (res.status) {
            // console.log("Contract created successfully",res.contractid);
            // console.log("Contract created successfully",res);
            if(Number(res.contractid) > 0){
              sessionStorage.setItem("contract_id", res.contractid);
              nextStep(true,{contractid: res.contractid})
            }
          }
          else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  });




  const allClient = async () => {
    if (formik.values.module_type == "" || formik.values.module_type == null || formik.values.module_type == undefined) return;
    const agent_db = localStorage.getItem('agent_db');
    const req = {
      agent_db: agent_db,
      company_id: company_id,
      pricing_tool_pratice_id: agent_id,
      module: formik.values.module_type,
    };
    const token_crm = localStorage.getItem('authClientToken');
    const agent_url = localStorage.getItem('agent_url');

    await getAllClient(req, agent_url, token_crm).then((res) => {
      if (res.IsSuccess) {
        setAllClientData(res.result);
      } else {
        setAllClientData([]);
      }
    }).catch((err) => {
      console.log("err", err);
    });
  };

  const getSingleClientDetails = async () => {
    if (formik.values.module_type == "" || formik.values.module_type == null || formik.values.module_type == undefined) return;

    const agent_db = localStorage.getItem('agent_db');
    const req = {
      agent_db: agent_db,
      company_id: company_id,
      pricing_tool_pratice_id: agent_id,
      module: formik.values.module_type,
      record_id: formik.values.Client || 0,
    };

    const token_crm = localStorage.getItem('authClientToken');
    const agent_url = localStorage.getItem('agent_url');

    await getClientDetails(req, agent_url, token_crm).then((res) => {
      if (res.IsSuccess) {
        setClientsingledetailsError(false);
        setClientDetails(res.result);
        let business_type_details = quoteDataAllInfo?.business_type?.find((item) => (item.name)?.toLowerCase() == (res?.result?.business_type)?.toLowerCase());
        let client_type_details = quoteDataAllInfo?.enquiry_type?.find((item) => (item.name)?.toLowerCase() == (res?.result?.client_type)?.toLowerCase());
        let channel_details = quoteDataAllInfo?.channel?.find((item) => (item.name)?.toLowerCase()?.replace(/\s+/g, "") == (res?.result?.channel)?.toLowerCase()?.replace(/\s+/g, ""));

        if (business_type_details == undefined) {
          setCheckBusinessType(true);
        } else {
          setCheckBusinessType(false);
          formik.setFieldValue("BusinessType", business_type_details?.id);
        }

        if (client_type_details == undefined) {
          setCheckClientType(true);
        } else {
          setCheckClientType(false);
          formik.setFieldValue("EnquiryType", client_type_details?.id);
        }

        if (channel_details == undefined) {
          setCheckChannel(true);
        } else {
          setCheckChannel(false);
          formik.setFieldValue("Channel", channel_details?.id);
        }

      } else {
        setClientsingledetailsError(true);
        setClientDetails([]);
      }
    }).catch((err) => {
      setClientsingledetailsError(true);
      console.log("err", err);
    });
  };

 const contractDefination = [
  "New",
  "Renewal",
  "Add-on",
 ]

  const fields = [
    {
      type: "select1",
      name: "module_type",
      label: "I would like to create a contract for:",
      options: [
        { value: "Leads", label: "Leads" },
        { value: "Accounts", label: "Clients" },
        { value: "Contacts", label: "Contacts" },
      ],
      label_size: 6,
      col_size: 7,
      disable: QuoteId == null || QuoteId == 0 ? false : true,
      child_col_size: 6,
    },

    {
      type: "singleselect1",
      name: "Client",
      label: "Name:",
      options: Object.entries(allClientData || {}).map(([key, value]) => ({
        value: key,
        label: cleanHtmlEntities(value),
      })),

      label_size: 6,
      col_size: 7,
      disable: QuoteId == null || QuoteId == 0 ? false : true,
      child_col_size: 6,
    },


    {
      type: "select1",
      name: "EnquiryType",
      label: "Enquiry Type:",
      options: quoteDataAllInfo?.enquiry_type?.map((item) => ({
        value: item?.id,
        label: item?.name,
      })),
      label_size: 6,
      col_size: 7,
      disable: checkClientType == false || QuoteId ? true : false,
      child_col_size: 6,
    },

    {
      type: "select1",
      name: "BusinessType",
      label: "Business Type:",
      options: quoteDataAllInfo?.business_type?.map((item) => ({
        value: item?.id,
        label: item?.name,
      })),
      label_size: 6,
      col_size: 7,
      disable: checkBusinessType == false || QuoteId ? true : false,
      child_col_size: 6,
    },


    {
      type: "select1",
      name: "Channel",
      label: "Channel:",
      options: quoteDataAllInfo?.channel?.map((item) => ({
        value: item?.id,
        label: item?.name,
      })),
      label_size: 6,
      col_size: 7,
      disable: checkChannel == false || QuoteId ? true : false,
      child_col_size: 6,
    },

    {
      type: "text",
      name: "ContractOwner",
      label: "Sales Person:",
      placeholder: "Please enter Contract owner",
      label_size: 6,
      col_size: 7,
      disable: true,
      child_col_size: 6,
    },
    {
      type: "select1",
      name: "contract_definition",
      label: "Contract Definition:",
      options: [
        { value: "", label: "Select an option" },
        ...contractDefination?.map((item) => ({
          value: item,
          label: item,
        })),
      ],
      label_size: 6,
      col_size: 7,
      disable: false,
      child_col_size: 6,
    },
  ];


  useEffect(() => {
    if (formik.values.Client && quoteDataAllInfo?.business_type?.length > 0) {
      getSingleClientDetails();
    }
  }, [formik.values.Client]);

  useEffect(() => {
    formik.validateForm();
  }, [clientDetails]);

  useEffect(() => {
    formik.setFieldValue("ContractOwner", ContractOwner?.user_fname + " " + ContractOwner?.user_lname);
  }, []);


  useEffect(() => {
    allClient();
  }, [formik.values.module_type]);



  useEffect(() => {
    const fetchData = async () => {
      if (location.state !== undefined && location.state !== null && location.state.record_id !== undefined && location.state.module_type !== undefined) {

        setIsLoading(true);
        let req = { agent_id: agent_id };
        try {
          const resQuoteDataAllInfo = await dispatch(getQuoteInfo(req)).unwrap();
          formik.setFieldValue("module_type", location.state.module_type);
          formik.setFieldValue("Client", location.state.record_id);
          if (resQuoteDataAllInfo.status) {
            const agent_db = localStorage.getItem('agent_db');
            const req = {
              agent_db: agent_db,
              company_id: company_id,
              pricing_tool_pratice_id: agent_id,
              module: location.state.module_type,
              record_id: location.state.record_id || 0,
            };

            const token_crm = localStorage.getItem('authClientToken');
            const agent_url = localStorage.getItem('agent_url');
            await getClientDetails(req, agent_url, token_crm).then(async (res) => {
              if (res.IsSuccess) {
                setClientDetails(res.result);
                let business_type_details = resQuoteDataAllInfo.data?.business_type?.find((item) => (item.name).toLowerCase() == (res.result.business_type).toLowerCase());
                let client_type_details = resQuoteDataAllInfo.data?.enquiry_type?.find((item) => (item.name).toLowerCase() == (res.result.client_type).toLowerCase());
                let channel_details = resQuoteDataAllInfo.data?.channel?.find((item) => (item.name).toLowerCase().replace(/\s+/g, "") == (res.result.channel).toLowerCase().replace(/\s+/g, ""));

                if (business_type_details == undefined) {
                  setCheckBusinessType(true);
                } else {
                  setCheckBusinessType(false);
                  formik.setFieldValue("BusinessType", business_type_details?.id);
                }

                if (client_type_details == undefined) {
                  setCheckClientType(true);
                } else {
                  setCheckClientType(false);
                  formik.setFieldValue("EnquiryType", client_type_details?.id);
                }

                if (channel_details == undefined) {
                  setCheckChannel(true);
                } else {
                  setCheckChannel(false);
                  formik.setFieldValue("Channel", channel_details?.id);
                }

                setIsLoading(false);

              } else {
                setClientDetails([]);
              }
            }).catch((err) => {
              console.log("err", err);
            });


          }

        } catch (err) {
          console.error("err", err);
        }
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',

        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);




  return (
    <div>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/contracts/contracts-dashboard"
              onClick={() => sessionStorage.clear()}
            >
              <i className='bx bx-arrow-back text-pink pe-1'></i>
            </Link>
            New Contract
          </h4>
        </div>
      </div>
      <div className="card form-card">
        <div className="card-header">
          <h5 className="card-title">
            {location.state != undefined && location.state != null ? "Edit Contract" : "Create New Contract"}
          </h5>
        </div>
        <div className="card-body">
          <ReusableForm
            fieldtype={fields.filter(
              (field) => !field.showWhen || field.showWhen(formik.values)
            )}
            formik={formik}
            hide_close_btn={true}
            hide_submit_btn={true}
            test={true}
          />

          <div className="d-flex justify-content-between mt-3">
            {currentStep > 1 && (
              <button className="btn btn-secondary" onClick={prevStep}>
                Previous
              </button>
            )}
            <button className="btn btn-pink" onClick={formik.handleSubmit}>
              {currentStep < 3 ? "Next" : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepOne;